const initialState = {
  programTransitionalStaffId: '',
  drug1UsedId: '',
  drug1InTakeId: '',
  drug1FrequencyId: '',
  drug2UsedId: '',
  drug2InTakeId: '',
  drug2FrequencyId: '',
  drug3UsedId: '',
  drug3InTakeId: '',
  drug3FrequencyId: '',
  drug4UsedId: '',
  drug4InTakeId: '',
  drug4FrequencyId: '',
  drug1AgeFirstUsed: '',
  drug2AgeFirstUsed: '',
  drug3AgeFirstUsed: '',
  drug4AgeFirstUsed: '',
  LengthofTimeSinceClientLastUsed: '',
  TimeSpentinInstitutions: '',
  LongestLengthofNonUse: '',
  TotalLengthofUse: '',
  program1Name: '',
  program2Name: '',
  program3Name: '',
  program1Modality: '',
  program2Modality: '',
  program3Modality: '',
  program1Year: '',
  program2Year: '',
  program3Year: '',
  program1Completed: '',
  program2Completed: '',
  program3Completed: '',
  program1TreatmentLength: '',
  program2TreatmentLength: '',
  program3TreatmentLength: '',
  treatmentAccomplishments: '',
  referredForTreatment: '',
  notReferredInappropriate: '',
  notReferredRefusingTreatment: '',
  residential: '',
  soberLiving: '',
  outPatient: '',
  dayTreatment: '',
  recommendResidentialWithChild: '',
  recommendSoberLivingWithChild: '',
  recommendSoberLivingWithIntensiveOdf: '',
  FOTEP: '',
  commentOnRecommendations: '',
  dateSigned: '',
  isProfA2DataLoaded: false,
};

export default initialState;
